import React from 'react';
import { useTranslation } from 'react-i18next';
import './support.css';

const Support = () => {
  const { t } = useTranslation();

  const supporters = [
    {
      id: 1,
      logo: '/images/supporters/mo.png',
      url: 'https://muuseumioo.muuseum.ee/',
    },
    {
      id: 2,
      logo: '/images/supporters/kop.png', 
      url: 'https://ivol.ee/', 
    },
    {
      id: 3,
      logo: '/images/supporters/logo2.png',
      url: 'https://www.narva.ee/',
    },
    {
      id: 4,
      logo: '/images/supporters/ERK.png',
      url: 'https://rahvakultuur.ee/',
    },
        {
      id: 5,
      logo: '/images/supporters/narvagate.svg',
      url: 'https://narvagate.eu/',
    },
            {
      id: 6,
      logo: '/images/supporters/fama.png',
      url: 'https://astri.ee/fama/',
    },
        {
      id: 7,
      logo: '/images/supporters/uussamm.jpg',
      url: 'https://uussamm.ee/',
    },
            {
      id: 8,
      logo: '/images/supporters/neo.jpg',
      url: '',
    },
    {
      id: 9,
      logo: '/images/supporters/ingerLogo.jpg', 
      url: 'https://inger.ee/', 
    },
        {
      id: 10,
      logo: '/images/supporters/ezdunyLogo.jpg', 
      url: 'https://www.facebook.com/groups/897980441404687', 
    },
            {
      id: 11,
      logo: '/images/supporters/cramo.jpg', 
      url: 'https://www.cramo.ee/', 
    },
            {
      id: 12,
      logo: '/images/supporters/firepro.jpg', 
      url: 'https://www.firepro.ee/', 
    },
            {
      id: 13,
      logo: '/images/supporters/blistex.png', 
      url: 'https://blistex.ee/', 
    },
  ];

  return (
    <section id="support" className="support">
      <h2 className="support-title">{t('support.title')}</h2>
      <div className="support-logos">
        {supporters.map((supporter) => (
          <a
            key={supporter.id}
            href={supporter.url || '#'} // Если ссылки нет, то #
            target="_blank" // в новой вкладке
            rel="noopener noreferrer" // Безопасность
            className="support-logo-link"
          >
            <img
              src={supporter.logo}
              alt={t('support.logoAlt', { id: supporter.id })}
              className="support-logo"
            />
          </a>
        ))}
      </div>
    </section>
  );
};

export default Support;